import CityMapProduct from './components/CityMapProduct'
import CityMapLoader from './components/CityMapLoader'

export default {
    install(Vue, option) {
        Vue.component('CityMapProductWebGL', CityMapProduct);
        Vue.component('CityMapLoader', CityMapLoader);
    }
};